import apiUrl from '../configs/apiUrl'
import { pathNames } from '../routers/router'
import { axiosPost } from '../utils/axios'
import { getRefreshToken } from '../utils/sessionStorage'
import { keyNameSessionStorage, setSessionStorage } from '../utils/sessionStorage'
interface AuthWebBaseResponse {
    accessToken: string
    refreshToken: string
}
const usePortal = () => {
    const refreshToken = getRefreshToken()

    const authWebBase = async (refreshToken?: string) => {
        const { request } = axiosPost<AuthWebBaseResponse>({
            url: apiUrl.webBaseAuth,
            params: { refreshToken },
        })
        const { data } = await request
        return data
    }

    const goToWebBase = async () => {
        try {
            let authResponse
            if (refreshToken) {
                authResponse = await authWebBase(refreshToken as string)
            }
            if (authResponse && authResponse?.refreshToken && authResponse?.accessToken) {
                // set กรณี ไม่ทัน ได้เฉพาะ domain เดียวกัน
                setSessionStorage(keyNameSessionStorage.accessToken, authResponse.accessToken)
                setSessionStorage(keyNameSessionStorage.refreshToken, authResponse.refreshToken)
                window.location.assign(
                    process.env.REACT_APP_WEBBASE_PATH_AUTH_URL +
                        '?accessToken=' +
                        authResponse.accessToken +
                        '&refreshToken=' +
                        authResponse.refreshToken,
                )
            } else {
                window.location.href = process.env.PUBLIC_URL + pathNames['signIn']
            }
        } catch (err) {
            console.log(' go to web base', err)
            window.location.href = process.env.PUBLIC_URL + pathNames['signIn']
        }
    }
    return { goToWebBase }
}
export default usePortal
